import { FieldError } from 'react-hook-form';
import { FC } from 'react';

import { Termostatstyring } from '../../../../../utils/registerEnums';

import { EnumRadioButton } from './enumRadioButton';
import { EnumRadioGroup } from './enumRadioGroup';

interface Props {
  value?: Termostatstyring;
  labelKey: string;
  informationKey: string;
  error?: FieldError;
  onChange: (value?: string) => void;
}

export const TermostatstyringRadio: FC<Props> = ({ error, onChange, value, labelKey, informationKey }) => (
  <EnumRadioGroup value={value} error={error} labelKey={labelKey} helperTextKey={informationKey} onChange={onChange}>
    <EnumRadioButton i18nPrefix="register" value={Termostatstyring.TermostatstyrtUtenTidsstyring} />
    <EnumRadioButton i18nPrefix="register" value={Termostatstyring.TermostatstyrtMedTidsstyring} />
    <EnumRadioButton i18nPrefix="register" value={Termostatstyring.UtenTermostat} />
    <EnumRadioButton i18nPrefix="register" value={Termostatstyring.Ukjent} />
  </EnumRadioGroup>
);
